<template>
  <div class="banner-wrapper gap-2 relative">
    <div
      class="banner flex gap-x-12 gap relative py-4 items-center h-fit md:h-auto max-sm:flex-wrap-reverse min-h-[420px] sm:min-h-[420px]"
      :style="{
        backgroundColor: (!bgImage ? bgColor : null) || 'transparent',
      }"
    >
      <div
        v-if="bgImage || bgColor"
        class="banner_heading_bg -z-[-1] absolute w-full h-full left-0 pointer-events-none"
        :style="{
          backgroundColor: (!bgImage ? bgColor : null) || 'transparent',
        }"
      >
        <NuxtImg
          v-if="bgImage"
          :src="bgImage"
          class="banner__image rounded w-full h-full object-cover hidden md:block"
          alt="Giftcard"
          :height="'auto'"
          aspect-ratio="auto"
          sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw"
          preload
        />
        <NuxtImg
          v-if="bgImageMobile"
          :src="bgImageMobile"
          class="banner__image rounded w-full h-full object-cover md:hidden"
          alt="Giftcard"
          :height="'auto'"
          aspect-ratio="auto"
          sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw"
          preload
        />
      </div>
      <div
        v-if="text || description"
        class="banner__container flex w-full max-w-[450px] md:p-0 py-4 md:py-7 [&.padded]:md:px-8 flex-col justify-center overflow-hidden break-words"
        :class="{
          padded: padded,
        }"
      >
        <div class="banner__heading">
          <Heading
            :level="1"
            :title="text"
            h-class="text-h2"
            class="kft-heading--left"
            :test-id="testId"
          />
          <p v-if="description" class="banner__description mt-1">
            {{ description }}
          </p>
        </div>

        <GiftcardBuyBox v-if="showGiftbox" class="mt-2" />

        <slot name="button">
          <Button
            v-show="!hideButton"
            class="w-100 mt-6"
            :link="callToActionLink"
            @click="action"
          >
            {{ actionLabel }}
          </Button>
        </slot>
      </div>
      <slot v-if="$slots.default"></slot>
      <div
        v-else
        v-show="featuredMedia.slice(0, 1).length > 0"
        class="banner__side-gallery max-sm:overflow-hidden sm:empty:hidden h-[240px] h-max sm:h-[450px] min-w-[60%] w-full relative before:rounded-xl before:top-0 before:left-0 sm:before:top-5 sm:before:-left-5"
      >
        <div
          v-for="img in featuredMedia.slice(0, 1) || []"
          :key="img.id"
          class="side-image-container relative shrink-0 w-full h-full"
        >
          <component :is="img.url ? 'a' : 'div'" :href="img.url" class="h-full">
            <NuxtImg
              :src="String(img?.src)"
              :alt="img.alt"
              class="banner__image h-full w-full rounded-lg sm:rounded-xl object-cover"
              :height="'auto'"
              aspect-ratio="auto"
              sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw"
              preload
            />
          </component>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    height: {
      type: Number,
      default: 240,
    },
    bgColor: {
      type: String,
      default: null,
    },
    padded: {
      type: Boolean,
      default: false,
    },
    bgImage: {
      type: String,
      default: null,
    },
    bgImageMobile: {
      type: String,
      default: null,
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
    action: {
      type: Function,
      default: () => () => null,
    },
    callToActionLink: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    testId: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    featuredMedia: {
      type: Array,
      default: () => [],
    },
    actionLabel: {
      type: String,
      default: null,
    },
    showGiftbox: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="postcss" scoped>
.banner-wrapper .banner__side-gallery {
}
.banner-wrapper .banner__side-gallery:before {
  position: absolute;
  @apply md:bg-lime-200;
  display: block;
  content: '';
  width: 100%;
  height: 100%;
}
.banner-wrapper .banner__side-gallery .banner-gallery-image-text {
  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
}
</style>
